










import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import addTaskPageWithParam from './addTaskPageWithParam.vue'

@Component({
	name: 'LinkAddTask',
	components: {
		addTaskPageWithParam,
	},
})
export default class AddTask extends Vue {}
